/* assets/feature-1-color-to-5-tonal.js
   «1 color = 5 colors»  (упрощённая версия)
   ▸ клик по надписи – ждём щелчка по любому объекту в #imported-Label
   ▸ все пять переменных (--c1…--c5) получают оттенки выбранного цвета
   ▸ никаких попыток «зафиксировать» исходный fill объекта — сам элемент
     тоже может перекраситься, как и всё остальное                       */

;(function () {
/* ─── HSL helpers ─────────────────────────────────── */
const rgbToHsl=(R,G,B)=>{R/=255;G/=255;B/=255;
  const M=Math.max(R,G,B),m=Math.min(R,G,B);let h=0,s=0,l=(M+m)/2;
  if(M!==m){const d=M-m;s=l>.5?d/(2-M-m):d/(M+m);
    h=M===R?((G-B)/d+(G<B?6:0)):M===G?((B-R)/d+2):((R-G)/d+4);h/=6;}return[h,s,l];};

const hslToRgb=(h,s,l)=>{const f=(p,q,t)=>{t<0&&(t+=1);t>1&&(t-=1);
  if(t<1/6)return p+(q-p)*6*t;if(t<1/2)return q;if(t<2/3)return p+(q-p)*(2/3-t)*6;return p;};
  if(!s)return[l,l,l].map(v=>v*255);
  const q=l<.5?l*(1+s):l+s-l*s,p=2*l-q;
  return[f(p,q,h+1/3),f(p,q,h),f(p,q,h-1/3)].map(v=>v*255);};

const css=rgb=>`rgb(${rgb.map(Math.round).join(',')})`;

function build(rgb){
  const [h,s,l]=rgbToHsl(...rgb), dark=l<.5, t=a=>hslToRgb(h,s,Math.max(0,Math.min(1,l+a)));
  return {
    '--c1': css(rgb),
    '--c4': css(t(dark? +.10 : -.10)),
    '--c3': css(t(dark? +.30 : -.30)),
    '--c2': css(t(dark? +.45 : -.45)),
    '--c5': css(t(dark? +.60 : -.60))
  };
}

/* ─── apply palette (root + текущий SVG) ─────────── */
function applyVars(p){
  const root=document.documentElement.style;
  for(const[k,v] of Object.entries(p)) root.setProperty(k,v,'');

  const svg=document.getElementById('imported-Label')?.closest('svg');
  if(svg){
    const st=svg.style;
    for(const[k,v] of Object.entries(p)) st.setProperty(k,v,'');
  }
  console.table(p);
}

/* ─── ожидание клика ─────────────────────────────── */
let armed=false,pickFn=null;
const host = ()=>document.getElementById('imported-Label');

function enable(){
  const h=host(); if(!h){console.warn('[1→5] нет imported-Label');return;}
  armed=true;
  pickFn=ev=>{
    const el=ev.target.closest('path,rect,circle,ellipse,polygon,polyline,text,use');
    if(!el){disable();return;}
    const m=getComputedStyle(el).fill.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
    if(!m){disable();return;}
    applyVars( build([+m[1],+m[2],+m[3]]) );
    disable();
  };
  h.addEventListener('click',pickFn,{once:true});
  console.log('[1→5] ждём клик…');
}
function disable(){
  armed=false;
  const h=host(); h&&pickFn&&h.removeEventListener('click',pickFn);
  pickFn=null;
}

/* при подмене SVG переносим ожидание */
eventHub.addEventListener('svg-imported',()=>{ if(armed){ disable(); enable(); }});

/* ─── кнопка ─────────────────────────────────────── */
(function waitBtn(){
  const btn=[...document.querySelectorAll('text.st1-answer')]
              .find(t=>t.textContent.trim().toLowerCase()==='1 color = 5 colors');
  if(!btn) return setTimeout(waitBtn,200);
  btn.style.cursor='pointer'; btn.style.pointerEvents='all';
  btn.addEventListener('click',()=> armed ? disable() : enable());
  console.log('[1→5] кнопка готова');
})();
})();
